/**
 * Проверяет, есть ли в jsonQuery инфа о цене.
 */
import { IJsonQuery } from '@cian/api-models/common/json_query';

export function hasPrice(jsonQuery: IJsonQuery): boolean {
  return jsonQuery.price !== undefined;
}
